module.exports = __webpack_public_path__ + "img/water-lg.c26b4984.svg";